import React, { useState } from 'react';
import { rebuildHighSchoolsIndex } from '../../services/algolia';

function ImportRebuildHighSchools() {
    const [status, setStatus] = useState(null);

    async function rebuildIndex() {
        setStatus('Rebuilding...');
        try {
            await rebuildHighSchoolsIndex();
            setStatus('Done! The PROD_HIGH_SCHOOLS index is up to date.');
        } catch (error) {
            console.log('Error rebuilding HighSchools index: ', error);
            setStatus('Error rebuilding index. Check the console for details.');
        }
    }

    return (
        <div>
            <h3 style={{ marginBottom: '20px' }}>
                Rebuild High Schools Index
            </h3>

            <p>
                One-time sync: pushes every row in the HighSchools table into the
                PROD_HIGH_SCHOOLS Algolia index, resolving any legacy records so
                future edits made in the admin HighSchools screen update this index
                automatically. Safe to re-run any time.
            </p>

            <p><button style={{ marginTop: '5px' }} className="btn btn-success" onClick={() => rebuildIndex()}>
               Rebuild Index →
            </button></p>

            {status && <p>{status}</p>}
        </div>
    );
}

export default ImportRebuildHighSchools;
